@if (surveyRespondentDetails) {
  <div class="grid gap-x-12 gap-y-6 grid-cols-2 w-full">
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Created at</div>
      <div class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text h-[50px] flex items-center">
        <div>{{ surveyRespondentDetails.createdAt | date:'dd/MM/yyyy' }}</div>
      </div>
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Modified at</div>
      <div class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text h-[50px] flex items-center">
        <div>{{ surveyRespondentDetails.modifiedAt | date:'dd/MM/yyyy' }}</div>
      </div>
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">First Name</div>
      <input
        type="text"
        class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
        [(ngModel)]="surveyRespondentDetails.firstName"
        [readonly]="!editing"
        />
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Last Name</div>
      <input
        type="text"
        class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
        [(ngModel)]="surveyRespondentDetails.lastName"
        [readonly]="!editing"
        />
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Email</div>
      <input
        type="text"
        class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
        [(ngModel)]="surveyRespondentDetails.email"
        [readonly]="!editing"
        />
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Mobile Number</div>
      <input
        type="text"
        class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
        [(ngModel)]="surveyRespondentDetails.mobileNumber"
        [readonly]="!editing"
        />
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Date of Birth</div>
      <input
        type="date"
        class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
        [(ngModel)]="surveyRespondentDetails.dateOfBirth"
        [readonly]="!editing"
        />
    </div>
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Ethnicities</div>
      <mat-select
        class="!inter-300 w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border text-textbox-text h-[50px]"
        [multiple]="true"
        [(ngModel)]="surveyRespondentDetails.ethnicities"
        [disabled]="!editing"
        >
        @for (option of Ethnicity | keyvalue:unsorted; track option) {
          <mat-option [value]="option.value">{{ option.value }}</mat-option>
        }
      </mat-select>
    </div>
    @if (surveyRespondentDetails.ethnicities.includes(Ethnicity.other)) {
      <div>
        <div class="inter-400 text-[13px] text-support-text mb-2">Other ethnicity</div>
        <input
          type="text"
          class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
          [(ngModel)]="customEthnicity"
          [readonly]="!editing"
          />
      </div>
    }
    <div>
      <div class="inter-400 text-[13px] text-support-text mb-2">Gender</div>
      <mat-select
        class="!inter-300 w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border text-textbox-text h-[50px]"
        [(ngModel)]="surveyRespondentDetails.gender"
        [disabled]="!editing"
        >
        @for (option of Gender | keyvalue:unsorted; track option) {
          <mat-option [value]="option.value">{{ option.value }}</mat-option>
        }
      </mat-select>
    </div>
    @if (surveyRespondentDetails.gender === Gender.selfDescribe) {
      <div>
        <div class="inter-400 text-[13px] text-support-text mb-2">Other gender</div>
        <input
          type="text"
          class="w-full p-3 rounded-[12px] bg-textbox-fill border border-textbox-border inter-300 text-textbox-text placeholder:text-textbox-placeholder focus:outline-none focus:border-textbox-border h-[50px] read-only:opacity-70"
          [(ngModel)]="customGender"
          [readonly]="!editing"
          />
      </div>
    }
  </div>

  <div class="w-full flex justify-end mt-6">
    @if (editing) {
      <button
        (click)="updateRespondent()"
        matRipple
        class="px-4 py-2 rounded-full border border-nav-btn-border bg-transparent text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text inter-500 text-sm transition-colors">
        Save
      </button>
    }
    @if (!editing) {
      <button
        (click)="editing = true"
        matRipple
        class="px-4 py-2 rounded-full border border-nav-btn-border bg-transparent text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text inter-500 text-sm transition-colors">
        Edit
      </button>
    }
  </div>
}
